/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unstable-nested-components */
// @ts-nocheck

import type { FC } from "react";
import Link from "next/link";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import styles from "./MarkDownComp.module.scss";
import { useRouter } from "next/router";
import responsiveColumn from "../../../../../methods/responsiveColumn";
import { Button, Card, Col, Grid, Menu, Row } from "antd";
import type { CustomMenuItemType } from "../../../../../interfaces/menu";
import type { DefaultTFuncReturn } from "i18next";
import type { StaticBoxProps } from "../../../../../interfaces/globalProps";

export interface MarkDownCompProps {
  MenuTitle: string;
  content: string;
  selectedMenuItem: StaticBoxProps;
  menuItems: CustomMenuItemType[];
  buttonText: DefaultTFuncReturn;
  buttonLink: string;
}

export const MarkDownComp: FC<MarkDownCompProps> = ({
  MenuTitle,
  content,
  selectedMenuItem,
  menuItems,
  buttonText,
  buttonLink,
}) => {
  const router = useRouter();
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();

  return (
    <Row
      justify={"center"}
      style={{ paddingTop: 30, paddingBottom: 30, lineHeight: 1.5 }}
      gutter={[30, 30]}
    >
      <Col
        {...responsiveColumn([10, 13, 16, 23, 23, 23])}
        className='practice_article'
      >
        <ReactMarkdown
          rehypePlugins={[rehypeRaw]}
          components={{
            // NOTE: In wordpress for the ul formatting
            // for diamond dropdown use ul class="diamond-icon"
            // for child of diamond dropdown use ul class="child-list"
            // for normal blacksquare ul icon no need to use any class names
            ul: ({ ...props }) => <ul className={styles.ulStyle} {...props} />,
            a: ({ href, children }) => {
              return href ? (
                <Link href={href} legacyBehavior>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                  <a
                    onClick={() => router.push(href)}
                    className={styles.hotLink}
                  >
                    {children}
                  </a>
                </Link>
              ) : null;
            },
          }}
          className={styles.markDownComp}
        >
          {content}
        </ReactMarkdown>
        <Link href={buttonLink}>
          <Button
            size='large'
            style={{
              background: "#254486",
              border: "#254486",
              color: "#fff",
              padding: "5px calc((100% - 200px) / 10)",
              fontSize: 15,
              marginTop: screenSize.md ? 30 : 20,
              height: "auto",
              whiteSpace: "normal",
            }}
          >
            {buttonText}
          </Button>
        </Link>
      </Col>
      <Col {...responsiveColumn([6, 6, 7, 23, 23, 23])}>
        <Card
          headStyle={{
            whiteSpace: "normal",
            textOverflow: "unset",
            padding: "24px 16px",
          }}
          title={
            <div
              style={{
                textAlign: "center",
                fontSize: 24,
                fontWeight: 600,
                lineHeight: 1.3,
                whiteSpace: "normal",
              }}
            >
              {MenuTitle}
            </div>
          }
          style={{ boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.25)" }}
        >
          <Menu
            defaultSelectedKeys={[selectedMenuItem.slug as string]}
            triggerSubMenuAction='click' // Disable highlighting on click
            mode='inline'
            disabledOverflow={true}
            style={{ border: 0 }}
            items={menuItems}
          />
        </Card>
      </Col>
    </Row>
  );
};
